import React from "react";
import AccountPersonalData from "../../../../components/MyAccount/PersonalData";
import AccountPassword from "../../../../components/MyAccount/Password";
import AccountDelete from "../../../../components/MyAccount/AccountDelete";
import { Helmet } from "react-helmet-async";
import PageNavigation from "../../../../components/Navigation/SummaryNavigation/PageNavigation";
import { Box, Typography } from "@mui/material";
import CallRecordConsent from "../../../../components/MyAccount/CallRecordConsent";
import LayoutAuthenticated from "@/src/containers/Layouts/LayoutAuthenticated";

export default function MyAccountPage() {
  const navigationLinks = [
    {
      target: "#personalData",
      label: "Persönliche Daten",
    },
    {
      target: "#password",
      label: "Passwort ändern",
    },
    {
      target: "#callRecordConsent",
      label: "Persönliche Zusammenfassung",
    },
    {
      target: "#delete",
      label: "Konto löschen",
    },
  ];

  return (
    <LayoutAuthenticated>
      <Helmet>
        <title>Mein Konto | Legalbird</title>
      </Helmet>
      <Box sx={{ marginBottom: "2rem" }}>
        <Typography variant={"h5"} component={"h1"}>
          <strong>Mein Konto</strong>
        </Typography>
        <Typography variant={"body1"} sx={{ marginBottom: "1rem" }}>
          Ihre persönlichen Daten und Kontoeinstellungen auf einen Blick.
        </Typography>
        <PageNavigation navigationLinks={navigationLinks} />
      </Box>
      <Box id={"personalData"} />
      <AccountPersonalData />
      <Box id={"password"} />
      <AccountPassword />
      <Box id={"callRecordConsent"} />
      <CallRecordConsent />
      <Box id={"delete"} />
      <AccountDelete />
    </LayoutAuthenticated>
  );
}
